import React from 'react';
import {useHeader} from '../../../../_metronic/layout';
import {useIntl} from 'react-intl';
import SubheaderBar from '../../_common/components/SubheaderBar';
import ContactsFilters from '../components/ContactsFilter';
import ContactsTable from '../components/ContactsTable';
import {ContactsProvider} from '../components/ContactsContext';

const Contacts = () => {
  const header = useHeader();
  header.setTitle(useIntl().formatMessage({
    id: 'contacts-page-header',
    defaultMessage: 'Contacts'
  }));

  return (
    <ContactsProvider>
      <SubheaderBar>
        <ContactsFilters/>
      </SubheaderBar>
      <ContactsTable/>
    </ContactsProvider>
  );
};

export default Contacts;
